import { agencyContract } from "./features/agency/contract";
import { authContract } from "./features/auth/contract";
import { discountCodeContract } from "./features/discount-code/contract";
import { reservationContract } from "./features/reservation/contract";
import { tripContract } from "./features/trip/contract";
import { OC } from "./utils";

export const ClientAPIContract = OC.router({
  trip: tripContract,
  auth: authContract,
  agency: agencyContract,
  reservation: reservationContract,
  discountCode: discountCodeContract,
});
export type ClientAPIContract = typeof ClientAPIContract;
